import { Skeleton } from '@/components/ui/skeleton'

export default function DataTableSkeleton({
  columns = 5,
  rows = 10,
  with_filter = true,
}: {
  columns?: number
  rows?: number
  with_filter?: boolean
}) {
  return (
    <div className='w-full space-y-3 overflow-auto'>
      {with_filter && (<div className='flex items-center justify-between'>
        <Skeleton className='h-8 w-[250px]' />
      </div>)}
      <div className='rounded-md border'>
        <div className='border-b'>
          <div className='flex h-10 items-center gap-4 px-4'>
            {Array.from({ length: columns }).map((_, i) => (
              <Skeleton key={i} className='h-4 w-40' />
            ))}
          </div>
        </div>
        <div>
          {Array.from({ length: rows }).map((_, i) => (
            <div
              key={i}
              className='flex h-16 items-center gap-4 border-b px-4 last:border-0'
            >
              {Array.from({ length: columns }).map((_, j) => (
                <Skeleton key={j} className='h-4 w-40' />
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className='flex items-center justify-between'>
        <Skeleton className='h-8 w-[100px]' />
        <Skeleton className='h-8 w-[200px]' />
      </div>
    </div>
  )
}